export default {
    SET_INVENTORIES_GROUPS: (state, payload) => {
        state.inventoriesGroups = payload
    },
    SET_INDIRECT_EXPENSES: (state, payload) => {
        state.indirectExpenses = payload
    },
    SET_INDIRECT_EXPENSES_FILTERED: (state, payload) => {
        state.indirectExpensesFiltered = payload
    },
    SET_ARTICLES: (state, payload) => {
        state.articles = payload
    },
    SET_ARTICLES_FILTERED: (state, payload) => {
        state.articlesFiltered = payload
    },
    SET_IVATYPES: (state, payload) => {
        state.ivaTypes = payload
    },
    SET_IVATYPES_FILTERED: (state, payload) => {
        state.ivaTypesFiltered = payload
    },
    SET_NEWENTRANCE: (state, payload) => {
        state.newEntrance = payload
    },
    SET_NEWENTRANCE_FILTERED: (state, payload) => {
        state.newEntranceFiltered = payload
    },
    SET_PACKAGINGS: (state, payload) => {
        state.allPackagings = payload
    },
}